/**
 * Exec pins have to be recognised by name: the scene JSON only carries node ids,
 * port keys and wires — no port types. Every node definition names its exec pins
 * `exec`, `exec_<n>` (sequence pins) or `on…` (`onFinished`, `onClick`,
 * `onSelect_red`), and no value pin uses those keys. Node types with differently
 * named exec pins (e.g. Branch with `true` / `false`) override
 * {@link GraphNode.isExecOutPort}.
 *
 * Custom-function pins are covered as well: the editor camel-cases user input and
 * generates `exec<n>` keys for exec parameters. The remaining gap is a *value*
 * parameter a user explicitly names `on…`, which would be treated as an exec pin.
 */
export function isExecPortKeyByConvention(portKey) {
    if (portKey === 'exec')
        return true;
    if (/^exec[_A-Z0-9]/.test(portKey))
        return true;
    return /^on[A-Z]/.test(portKey);
}
